// Config.js
const ENV = process.env.REACT_APP_ENV || "local";

const configMap = {
  local: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL_LOCAL,
    BASE_URL: process.env.REACT_APP_BASE_URL_LOCAL,
    ROUTER_BASENAME: process.env.REACT_APP_ROUTER_BASENAME_LOCAL,
  },
  demo: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL_DEMO,
    BASE_URL: process.env.REACT_APP_BASE_URL_DEMO,
    ROUTER_BASENAME: process.env.REACT_APP_ROUTER_BASENAME_DEMO,
  },
  prod: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL_PROD,
    BASE_URL: process.env.REACT_APP_BASE_URL_PROD,
    ROUTER_BASENAME: process.env.REACT_APP_ROUTER_BASENAME_PROD,
  },
};

export const API_BASE_URL = configMap[ENV].API_BASE_URL;
export const BASE_URL = configMap[ENV].BASE_URL;
export const ROUTER_BASENAME = configMap[ENV].ROUTER_BASENAME;

export const GA4_ID = process.env.REACT_APP_GA4_ID;

console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("REACT_APP_ENV:", ENV);
console.log("API_BASE_URL:", API_BASE_URL);
